import "./OurVineyard.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheBlissProcess from "./sections/TheBlissProcess";
import ADecadeOfArtistry from "./sections/ADecadeOfArtistry";
import BrewingMethods from "./sections/BrewingMethods";
import Footer from "@/reusable_sections/Footer";
export default function OurVineyardPage() {
  return <div>
      <MainNavigation />
      <TheBlissProcess />
      <ADecadeOfArtistry />
      <BrewingMethods />
      <Footer />
    </div>;
}